/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VerifiableIdentityAddress } from './verifiableIdentityAddress';
import { RecoveryIdentityAddress } from './recoveryIdentityAddress';
import { IdentityCredentials } from './identityCredentials';


/**
 * An [identity](https://www.ory.sh/docs/kratos/concepts/identity-user-model) represents a (human) user in Ory.
 */
export interface Identity { 
    /**
     * CreatedAt is a helper struct field for gobuffalo.pop.
     */
    created_at?: string;
    /**
     * Credentials represents all credentials that can be used for authenticating this identity.
     */
    credentials?: { [key: string]: IdentityCredentials; };
    /**
     * ID is the identity\'s unique identifier.  The Identity ID can not be changed and can not be chosen. This ensures future compatibility and optimization for distributed stores such as CockroachDB.
     */
    id: string;
    /**
     * NullJSONRawMessage represents a json.RawMessage that works well with JSON, SQL, and Swagger and is NULLable-
     */
    metadata_admin?: object | null;
    /**
     * NullJSONRawMessage represents a json.RawMessage that works well with JSON, SQL, and Swagger and is NULLable-
     */
    metadata_public?: object | null;
    organization_id?: string | null;
    /**
     * RecoveryAddresses contains all the addresses that can be used to recover an identity.
     */
    recovery_addresses?: Array<RecoveryIdentityAddress>;
    /**
     * SchemaID is the ID of the JSON Schema to be used for validating the identity\'s traits.
     */
    schema_id: string;
    /**
     * SchemaURL is the URL of the endpoint where the identity\'s traits schema can be fetched from.  format: url
     */
    schema_url: string;
    /**
     * State is the identity\'s state.  This value has currently no effect. active StateActive inactive StateInactive
     */
    state?: Identity.StateEnum;
    state_changed_at?: string;
    /**
     * Traits represent an identity\'s traits. The identity is able to create, modify, and delete traits in a self-service manner. The input will always be validated against the JSON Schema defined in `schema_url`.
     */
    traits: any | null;
    /**
     * UpdatedAt is a helper struct field for gobuffalo.pop.
     */
    updated_at?: string;
    /**
     * VerifiableAddresses contains all the addresses that can be verified by the user.
     */
    verifiable_addresses?: Array<VerifiableIdentityAddress>;
}
export namespace Identity {
    export type StateEnum = 'active' | 'inactive';
    export const StateEnum = {
        Active: 'active' as StateEnum,
        Inactive: 'inactive' as StateEnum
    };
}


